import { isBlockNode, type BlockTree } from '@shared/block-renderer';

/**
 * The block tree crosses the wire as JSON and comes back as JSON. The
 * round-trip is **lossless**, including for a block type this build does not
 * know: an unknown type is carried through untouched rather than dropped, so a
 * body authored against a newer deploy survives an older tab.
 *
 * No markup is ever produced here. The public renderer emits `<h2>`, `<p>` and
 * `<ul>` with no classes, and a rhythm rule bound to a class would work in a
 * mockup and do nothing in production.
 */

export function parseBlockTree(raw: unknown): BlockTree {
  if (!Array.isArray(raw)) return [];
  return raw.filter(isBlockNode);
}

export function serializeBlockTree(tree: BlockTree): BlockTree {
  // Structured clone rather than a shallow copy: the caller must not be able to
  // mutate a node it already handed over.
  return structuredClone(tree);
}

/** True when the two trees are the same document — used by the dirty check. */
export function isSameTree(left: BlockTree, right: BlockTree): boolean {
  return JSON.stringify(left) === JSON.stringify(right);
}
